export default class {
  constructor() {
    const btn = document.getElementById("spMenu-btn");
    const nav = document.getElementById("spMenu-nav");

    if (!btn || !nav) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      nav.classList.toggle("-open");
      btn.classList.toggle("-active");

      if (nav.classList.contains("-open")) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    });
  }
}
